module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell vux-cell-form-preview",
    class: {
      'vux-cell-no-border-intent': !_vm.borderIntent
    }
  }, [_c('div', {
    staticClass: "weui-form-preview__bd"
  }, _vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "weui-form-preview__item"
    }, [_c('label', {
      staticClass: "weui-form-preview__label",
      domProps: {
        "innerHTML": _vm._s(item.label)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "weui-form-preview__value",
      domProps: {
        "innerHTML": _vm._s(item.value)
      }
    })])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc7db1ca"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/cell-form-preview/index.vue
// module id = 607
// module chunks = 0